import { getQuestionTypeButton } from '@app/utils';
import { QuestionType } from '@data/sdk/match';

export const getQuestionTypeOptions = () => [
  {
    label: getQuestionTypeButton({ status: QuestionType.Standard, icon: false }),
    value: QuestionType.Standard,
    className: 'p-0',
  },
  {
    label: getQuestionTypeButton({ status: QuestionType.Physician, icon: false }),
    value: QuestionType.Physician,
    className: 'p-0',
  },
  {
    label: getQuestionTypeButton({ status: QuestionType.Distractor, icon: false }),
    value: QuestionType.Distractor,
    className: 'p-0',
  },
  {
    label: getQuestionTypeButton({ status: QuestionType.Proposed, icon: false }),
    value: QuestionType.Proposed,
    className: 'p-0',
  },
  {
    label: getQuestionTypeButton({ status: QuestionType.TrialSpecific, icon: false }),
    value: QuestionType.TrialSpecific,
    className: 'p-0',
  },
];
